import { lazy } from "react"
import {
  ACL_READ,
  ACL_SUBJECT_ORGANIZATION,
  ACL_SUBJECT_WAIT_ORGANIZATION,
  ACL_SUBJECT_PERSON,
  ACL_SUBJECT_IDENTIFICATION
} from "@configs/acl/constants"

const ManagementRoutes = [
  {
    path: "/management/persons",
    component: lazy(() => import("@views/management/persons")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PERSON
    }
  },
  {
    path: "/management/persons/add",
    component: lazy(() => import("@views/management/persons/PersonAdd")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PERSON
    }
  },
  {
    path: "/management/persons/change-account/:id",
    component: lazy(() => import("@views/management/persons/changeAccount/ChangeAccount")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PERSON
    }
  },
  {
    path: "/management/persons/:id/edit",
    component: lazy(() => import("@views/management/persons/PersonEditor")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PERSON
    }
  },
  {
    path: "/management/persons/:id",
    component: lazy(() => import("@views/management/persons/Person")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PERSON
    }
  },
  {
    path: "/management/organizations",
    component: lazy(() => import("@views/management/organizations")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/management/organizations/add",
    component: lazy(() => import("@views/management/organizations/CreateOrganization")
    ),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/management/organizations/:id/edit",
    component: lazy(() => import("@views/management/organizations/OrganizationEditor")
    ),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/management/organizations/:id",
    component: lazy(() => import("@views/management/organizations/Organization")
    ),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/management/identifications",
    component: lazy(() => import("@views/management/identifications")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_IDENTIFICATION
    }
  },
  {
    path: "/management/identifications/:id",
    component: lazy(() => import("@views/management/identifications/Identification")
    ),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_IDENTIFICATION
    }
  },
  {
    path: "/management/waiting-organizations/:id",
    component: lazy(() => import("@views/management/organizations/WaitingOrganizations")
    ),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_WAIT_ORGANIZATION
    }
  }
]

export default ManagementRoutes
